// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1059172360
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { DocumentType } from './models/common/documenttype';

export interface generateMemberCard_Filter {
  memberId: string;
  providerOnly: boolean;
  fileName: string;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentGenerationApiService {
  constructor(protected http: HttpClient) {}

  getTemplatedDocumentTypes(): Observable<DocumentType[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/DocumentGeneration/templates`;
    return this.http.get<DocumentType[]>(url);
  }

  generateMemberCard(
    queryParams?: Partial<generateMemberCard_Filter>
  ): Observable<string> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/DocumentGeneration/generate/member-card`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<string>(url, { params: params });
  }
}
